<template>
  <div class="task_logs">
    <div class="public-breadcrumb">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("devices.Welcome")
      }}</router-link>
      > {{ $t("taskLog.logs") }} >
      <span style="color: #3461ff">{{ $t("taskLog.Api logs") }}</span>
    </div>
    <div
      class="flex-between card-bg esls-page_top"
      style="padding: 20px; margin-bottom: 20px"
    >
      <div class="flex-between transmit-btn-box">
        <el-button
          size="small"
          class="transmit-btn top-btn"
          @click="rePushAll"
          :disabled="selectIds.length == 0"
          >{{ $t("taskLog.rePushAll") }}
          <i class="el-icon-refresh-right"></i>
        </el-button>
      </div>
    </div>
    <div class="table_set">
      <div class="select_filter">
        <div>
          <span class="text"
            >{{ $t("taskLog.Records") }}:{{ pageParams.total }}</span
          >
          <el-select
            v-model="pageParams.storeType"
            @change="getTaskScheduleLogListReq"
            size="small"
          >
            <el-option
              v-for="item in storeQueryTypeList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            />
          </el-select>
        </div>
      </div>
      <!-- @select-all="handleSelectAll" -->

      <el-table
        ref="tableRows"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        class="table-topstyle"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55">
          <el-table-column type="selection" :selectable="selectable" />
        </el-table-column>
        <el-table-column :label="$t('taskLog.Store Name')">
          <el-table-column prop="storeName" min-width="150">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.storeName"
                size="mini"
                @input="getTaskScheduleLogListReq"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="$t('taskLog.Item Name')"
          prop="itemName"
          sortable="custom"
        >
          <el-table-column prop="itemName" min-width="150">
            <template slot="header">
              <el-input
                clearable
                v-model="pageParams.itemName"
                size="mini"
                @input="getTaskScheduleLogListReq"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Task Type')">
          <el-table-column prop="taskType" min-width="150">
            <template slot="header">
              <el-select
                v-model="pageParams.taskType"
                size="mini"
                placeholder=""
                clearable
                @change="getTaskScheduleLogListReq"
              >
                <el-option
                  v-for="item in taskTypeList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
            <template slot-scope="scope">
              <span class="table-cell__task-type">
                <img
                  v-if="scope.row.taskType === 1207"
                  class="table-cell__task-type-icon"
                  src="@/assets/img/ic_switch_temp.png"
                />
                <img
                  v-if="scope.row.taskType === 1206"
                  class="table-cell__task-type-icon"
                  src="@/assets/img/ic_layout.png"
                />
                <img
                  v-if="scope.row.taskType === 1203"
                  class="table-cell__task-type-icon"
                  src="@/assets/img/ic_led.png"
                />
                <img
                  v-if="scope.row.taskType === 1204"
                  class="table-cell__task-type-icon"
                  src="@/assets/img/ic_switch_page.png"
                />
                <img
                  v-if="scope.row.taskType === 1205"
                  class="table-cell__task-type-icon"
                  src="@/assets/img/ic_nfc.png"
                />
                <span class="table-cell__task-type-name">{{
                  scope.row.taskTypeName
                }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('taskLog.Status')">
          <el-table-column prop="taskStateName" width="150">
            <template slot="header">
              <el-select
                v-model="pageParams.taskState"
                placeholder=""
                size="mini"
                clearable
                @change="getTaskScheduleLogListReq"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column :label="$t('taskLog.Result')">
          <el-table-column prop="stateName" width="150">
            <template slot="header">
              <el-select
                v-model="pageParams.state"
                placeholder=""
                size="mini"
                clearable
                @change="getTaskScheduleLogListReq"
              >
                <el-option
                  v-for="item in resultList"
                  :key="item.codeId"
                  :label="item.codeName"
                  :value="item.codeId"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 更新时间 -->
        <el-table-column
          :label="$t('taskLog.Update Time')"
          prop="updateTime"
          sortable="custom"
        >
          <el-table-column prop="updateTime" min-width="220">
            <template slot="header">
              <el-date-picker
                clearable
                v-model="pageParams.updateTime"
                type="daterange"
                align="center"
                size="mini"
                class="intergation_picker"
                unlink-panels
                range-separator="-"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="getTaskScheduleLogListReq"
              />
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column
          class="action"
          :label="$t('taskLog.Action')"
          width="130"
          fixed="right"
        >
          <el-table-column width="130">
            <template slot-scope="scope">
              <i
                class="el-icon-refresh-right"
                v-if="scope.row.taskState != 3502"
                @click="rePush(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <pagination :tableInfo="pageParams" @changePage="changePage" />
    </div>
    <!-- table -->
    <errors-log-dialog ref="errorsLogDialogRef" />
  </div>
</template>
<script>
import errorsLogDialog from "@/views/logs/integrations/dialog/errorsLog.vue";
import { commonStore } from "@/store/global-select-store";

import modelUi from "@/views/taskManagement/taskManger/utils/modelUi.js";

import { getCodeList } from "@/libs/api/taskManger.js";

import {
  parseResp,
  parseError,
} from "@/views/taskManagement/taskManger/utils/requestUtil.js";
import { getCallbackList, retryCallback } from "@/libs/api/logManger";

import { getStoreId } from "@/views/taskManagement/taskManger/utils/cacheUtil.js";
import pagination from "@/components/pagination";

export default {
  components: {
    errorsLogDialog,
    pagination,
  },
  data() {
    return {
      commonStore,
      stateList: [],
      resultList: [],
      taskTypeList: [],
      storeQueryTypeList: [
        {
          dictValue: 2,
          dictName: this.$t("ThisStore"),
        },
        {
          dictValue: 1,
          dictName: this.$t("ZimenStore"),
        },
        {
          dictValue: 0,
          dictName: this.$t("AllStore"),
        },
      ],
      leng: "",
      tableData: [],
      selectIds: [],
      pageParams: {
        current: 1,
        size: 10,
        total: 20,
        storeType: 2,
        storeName: "",
        itemName: "",
        taskType: "",
        state: "",
        taskState: "",
        updateTime: "",
        startError: "",
        endError: "",
        orders: [],
      },
    };
  },

  created() {
    commonStore.setInjectCallBack(this.initPage);
    // this.getTaskScheduleLogListReq()
    // this.getTaskTypeListReq()
    this.initPage();
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    language(val) {
      if (val) this.initPage();
    },
  },
  methods: {
    selectable(row, index) {
      // console.log(row.taskState)
      // console.log(row.taskState == 3502)
      if (row.taskState == 3502) {
        // 回调成功状态的数据不可选
        return false;
      } else {
        return true;
      }
    },
    rePushAll() {
      const params = {
        esTTaskCallbackLogIdList: this.selectIds,
      };
      this.$confirm(this.$t("taskLog.ComfirmInfo"), {
        confirmButtonText: this.$t("taskLog.Comfirm"),
        cancelButtonText: this.$t("taskLog.Cancel"),
        type: "warning",
        center: true,
      })
        .then(() => {
          retryCallback(params).then((res) => {
            console.log(res);
            if (res.data.code == 1) {
              this.$message.success(this.$t("taskLog.CommitSuccess"));
            }
          });
        })
        .catch(() => {});
    },
    rePush(row) {
      console.log(row);
      const params = {
        esTTaskCallbackLogIdList: [row.eslTaskCallbackLogId],
      };

      this.$confirm(this.$t("taskLog.ComfirmInfo"), {
        confirmButtonText: this.$t("taskLog.Comfirm"),
        cancelButtonText: this.$t("taskLog.Cancel"),
        type: "warning",
        center: true,
      })
        .then(() => {
          retryCallback(params).then((res) => {
            console.log(res);
            if (res.data.code == 1) {
              this.$message.success(this.$t("taskLog.CommitSuccess"));
            }
          });
        })
        .catch(() => {});
    },
    initPage() {
      this.getTaskScheduleLogListReq();
      this.getStateListReq();
      this.getResultListReq();
      this.getTaskTypeListReq();
    },
    changePage() {
      this.getTaskScheduleLogListReq();
    },
    handleSortChange(v1) {
      const { prop } = v1;
      const { order } = v1;
      let orderStr = "";
      if (order === "descending") {
        orderStr = "desc";
      }
      if (order === "ascending") {
        orderStr = "asc";
      }

      let keyName = "";
      if (prop === "itemName") {
        keyName = "item_name";
      }
      if (prop === "updateTime") {
        keyName = "update_time";
      }
      if (prop === "duration") {
        keyName = "duration";
      }
      if (prop === "errors") {
        keyName = "errors";
      }
      if (prop === "processeds") {
        keyName = "processeds";
      }

      if (orderStr) {
        const orders = [];
        const orderItem = `${orderStr}:${keyName}`;
        orders.push(orderItem);
        this.pageParams.orders = orders;
      } else {
        this.pageParams.orders = [];
      }
      this.getTaskScheduleLogListReq();
    },

    getResultListReq() {
      // 10  获取任务结果List
      getCodeList(10)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            let resultList = result.data;
            resultList = resultList.filter(
              (item) => item.codeValue == "4" || item.codeValue == "5"
            );
            console.log("resultList", resultList);
            this.resultList = resultList;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    getStateListReq() {
      // 回调日志状态传35
      getCodeList(35)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            this.stateList = result.data;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    getTaskTypeListReq() {
      getCodeList(12)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            let typeList = result.data;
            // typeList = typeList.filter(item => item.codeHelp === 'taskSchedule')
            // console.log('typeList',typeList)
            this.taskTypeList = typeList;
          } else {
            modelUi.msgError(result.message);
          }
        })
        .catch((err) => {
          modelUi.msgError(parseError(err));
        });
    },

    selection() {
      return this.$refs.tableRows && this.$refs.tableRows.selection.length;
    },
    handleSelectionChange(val) {
      console.log(val);
      if (val.length > 0) {
        this.selectIds = val.map((item) => {
          return item.eslTaskCallbackLogId;
        });
        console.log(this.selectIds);
      }
    },
    handleSelectAll() {
      const { isAllSelected } = this.$refs.tableRows.store.states;
      console.log(
        "selection==",
        this.$refs.tableRows.store.states.isAllSelected
      );
      if (isAllSelected) {
        const arr = [];
        selection.forEach((it) => {
          arr.push(...it.children);
        });
        this.selectChild(arr);
      } else {
        this.$refs.tableRows.clearSelection();
      }
    },
    // 获取列表数据
    getTaskScheduleLogListReq() {
      const {
        current,
        size,
        storeType,
        storeName,
        itemName,
        taskType,
        taskState,
        state,
        updateTime,
        orders,
      } = this.pageParams;
      let startDateStr = "";
      if (updateTime && updateTime.length > 0) {
        startDateStr = `${updateTime[0]} 00:00:00`;
      }

      let endDateStr = "";
      if (updateTime && updateTime.length > 0) {
        endDateStr = `${updateTime[1]} 23:59:59`;
      }

      // taskType	任务类型	是	Integer	query
      // taskState	任务状态，0：待回调；1：回调成功；2：回调失败；	是	Integer	query
      // coorName	基站名称	否	String	query
      // itemCode	条目条码	否	String	query
      // tagIdentity	价签条码	否	String	query
      // itemName	条目名称	否	String	query

      const data = {
        state,
        startDate: startDateStr,
        endDate: endDateStr,
        storeName,
        storeId: getStoreId(),
        storeType,
        taskType,
        taskState,
        itemName,
        current,
        size,
        orders,
      };
      this.getTaskScheduleLogList(data);
    },
    async getTaskScheduleLogList(data) {
      const res = await getCallbackList(data);
      console.log(res);
      this.rows = [];
      this.leng = res.data.data.total;
      this.pageParams.total = res.data.data.total;
      this.tableData = res.data.data.records;
    },
  },
};
</script>

<style lang="scss" scoped>
// .storelistrom {
// padding: 0 10px 10px;
// }
.task_logs {
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .card-bg {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
  &_top ::v-deep {
    padding: 20px;
    margin-bottom: 20px;
    .right-btn,
    .transmit-btn-box {
      .el-button > span {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .el-button {
      width: 140px;
      height: 34px;
      border-radius: 6px;
      padding: 0 16px;
      color: #ffffff;
      i {
        margin-right: 5px !important;
      }
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
    .danger-btn {
      background: #fc184d;
      color: #ffffff;
    }
    .gray-btn {
      background: #eeeeee;
      border: 1px solid #eeeeee;
      color: #666666;
      width: 80px;
    }
  }
  &_content {
    &-top {
      padding: 15px;
      font-size: 12px;
      // color: #999999;
      > span {
        margin-right: 10px;
      }
    }
    &-table ::v-deep {
      .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            width: 100% !important;
          }
        }

        .el-table__header-wrapper,
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table
        .el-table__header-wrapper
        .el-table__header
        .is-group
        tr:nth-of-type(2)
        th:nth-of-type(1)
        .cell {
        display: none;
      }
      .else-state {
        padding: 3px 18px;
        text-align: center;
        border-radius: 15px;
        display: inline-block;
      }
      .state-red {
        background: rgba(254, 202, 202, 1);
      }

      .state-blue {
        background: rgba(193, 233, 255, 1);
      }
    }
  }
  .txtalein {
    padding-bottom: 20px;
    color: #000;
    font-size: 12px;
  }
  .table-cell__task-type {
    background-color: #f1f1f1;
    border-radius: 14px;
    padding: 2px 16px;
    display: inline-block;
  }

  .table-cell__task-type-icon {
    width: 16px;
    height: 16px;
  }

  .table-cell__task-type-name {
    color: #555555;
    font-size: 14px;
    margin-left: 5px;
  }
  .integration_link {
    color: #000 !important;
    border-radius: 20px;
  }
  .integation_serch {
    margin-left: 10px;
    cursor: pointer;
  }
  .integation_serch:hover {
    color: brown;
  }
  .intergation_picker {
    width: 200px;
  }
}
.icon {
  padding: 6px;
  cursor: pointer;
  .svg-icon {
    width: 23px;
    height: 23px;
  }
}

.text {
  padding: 0 15px;
  font-size: 12px;
}
.table_set {
  border-radius: 6px;
  padding: 15px 0 0;
  background-color: white;
  .select_filter {
    padding-bottom: 15px;
    .table_label_size {
      width: 160px;
      font-size: 16px;
    }
    .table_select {
      width: 214px;
    }
  }
  .icon {
    padding: 6px;
    cursor: pointer;
    .svg-icon {
      width: 23px;
      height: 23px;
    }
  }
  .b_pag {
    // padding: 0 35px;
  }
  .tb_checkbox {
    vertical-align: middle;
  }
}
</style>
